import { $api } from "@/lib/api-client";

interface UseFetchFeedbackDetailParams {
  id: string;
  enabled?: boolean;
}

export const useFetchFeedbackDetail = ({
  id,
  enabled = true,
}: UseFetchFeedbackDetailParams) => {
  const result = $api.useQuery(
    "get",
    "/feedback/me/{id}",
    { params: { path: { id } } },
    { enabled: enabled && !!id },
  );

  return {
    ...result,
    data: result.data?.data,
  };
};
